import { createAsyncThunk } from '@/redux/createAsyncThunk';

import { fetchArticleByTopicAndSlug } from './article.api';
import { Article, ArticleRequestParams } from './article.types';

export const fetchArticle = createAsyncThunk<Article | null, ArticleRequestParams>(
    'la/ui/article/fetchArticle',
    async ({ slug, topic }) => {
        return fetchArticleByTopicAndSlug({ slug, topic });
    }
);
